import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-branch-select',
  templateUrl: './branch-select.component.html',
  styleUrls: ['./branch-select.component.css']
})
export class BranchSelectComponent implements OnInit {

  model = { 'branch_id': '0' };

  branch_list = [];
  Success_Msg; Error_Msg; Branch_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<BranchSelectComponent>,
    private route: ActivatedRoute, private router: Router,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Branch_Msg').subscribe((res: string) => {
      this.Branch_Msg = res;
    });

  }
  ngOnInit() {

    if (this.dialog_data != null) {
      this.branch_list = this.dialog_data;
    }
    else {
      let user_id = this.applicationConstants.user_info['user_id'];
      //get branch list:
      let query = "SELECT DISTINCT `branch`.`branch_id`, `branch`.* FROM `branch`," +
        " `branch_auth` WHERE `branch_auth`.`status` = '1' AND `branch_auth`.`branch_id` =" +
        " `branch`.`branch_id` AND `branch_auth`.`user_id` = '" + user_id + "' AND `branch`.`status` = '1'";

      let obj = { cmd: 'getList', query: query };
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          this.branch_list = data.data['list'];
        });
    }
  }

  save_branch() {
    if (this.model['branch_id'] == '0') {
      alert(this.Branch_Msg);
      return;
    }
      
    this.applicationConstants.user_branch_info.user_branch_id = this.model['branch_id'];
    // this.utils.getCustList(this.applicationConstants.user_branch_info.user_branch_id);
    
    this.branch_list.forEach(element => {
      if (element.branch_id == this.model['branch_id'])
        this.applicationConstants.user_branch_info.user_branch_name = element.branch_name;
    });

    //alert(this.Success_Msg);
    this.dialog_data = { 'op_type': 'success' };

    this.applicationConstants.user_branch_info.user_store_id = '0';
    this.applicationConstants.user_branch_info.user_store_name = ''
    let href = this.router.url;
    this.router.navigateByUrl('/user_main', { skipLocationChange: true }).then(() => {
      this.router.navigate([href]);
    }); 
  
    this.dialogRef.close(this.dialog_data);
  }

  cancel() {
    if (this.applicationConstants.user_branch_info.user_branch_id == '0') {
      alert(this.Branch_Msg);
      return;
    }

    this.dialog_data = { 'op_type': 'cancel' };
    this.dialogRef.close(this.dialog_data);
  }
}
